// Messages for the shared MetafieldEditor (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'metafields.title': 'Custom fields',
  'metafields.save': 'Save custom fields',
  'metafields.customer_visible': 'customer-visible',
  'metafields.select_placeholder': 'Select…',
  'metafields.select_none': '— none —',
  'metafields.yes': 'Yes',
  'metafields.no': 'No',
}

export const zhTW = {
  'metafields.title': '自訂欄位',
  'metafields.save': '儲存自訂欄位',
  'metafields.customer_visible': '客戶可見',
  'metafields.select_placeholder': '請選擇…',
  'metafields.select_none': '— 無 —',
  'metafields.yes': '是',
  'metafields.no': '否',
}
